import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {SlackIcon} from 'shells/icon/svg/slack-icon';
import {TwoLine} from 'shells/two-line/two-line';

import type {
    ClosedLeadSlackMessage as ClosedLeadSlackMessageFragment,
    SlackMessageAutomation as SlackMessageAutomationFragment,
} from 'nutshell-graphql-types';

import {SLACK, OPEN_LEAD_SLACK} from '../../constants';

import {SalesAutomationCard} from './sales-automation-card';

type Props = {
    slackAutomation: ClosedLeadSlackMessageFragment | SlackMessageAutomationFragment;
    parentId: string;
};

export class SalesAutomationCardSlack extends React.PureComponent<Props> {
    render() {
        return (
            <SalesAutomationCard
                type={
                    this.props.slackAutomation.__typename === 'ClosedLeadSlackMessage'
                        ? SLACK
                        : OPEN_LEAD_SLACK
                }
                borderColor={colors.grey}
                isHidden={false}
                parentId={this.props.parentId}
                entityId={this.props.slackAutomation.id}
            >
                {this.props.slackAutomation.slackChannel ? (
                    <TwoLine
                        icon={SlackIcon}
                        iconSize={24}
                        topRow={this.props.slackAutomation.slackChannel.display}
                        bottomRow={
                            this.props.slackAutomation.conditions.length
                                ? // @ts-expect-error
                                  this.props.slackAutomation.conditions[0]
                                      .humanReadableObjectiveString
                                : ''
                        }
                        // @ts-expect-error
                        isSalesAutomation={true}
                    />
                ) : (
                    <TwoLine
                        icon={SlackIcon}
                        iconSize={24}
                        topRow='Oh no! We couldn’t find that channel.'
                        // @ts-expect-error
                        isSalesAutomation={true}
                    />
                )}
            </SalesAutomationCard>
        );
    }
}
